import { Outlet } from "react-router-dom";
import { NavBar } from "../components/NavBar";

export function AppShell() {
  return (
    <>
      <NavBar live />
      <div id="content-wrapper">
        <Outlet />
      </div>
    </>
  );
}
